import ToastActionTypes from './toast-types'

const INITIAL_STATE = {
    display: false,
    toastDefinition: null,
    data: null,
}

const toastReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ToastActionTypes.START_TOAST_DISPLAY:
            return {
                ...state,
                display: true,
                toastDefinition: action.payload.toastDefinition,
                data: action.payload.data,
            }
        case ToastActionTypes.FINISH_TOAST_DISPLAY:
            return {
                ...state,
                display: false,
                toastDefinition: null,
                data: null,
            }

        default:
            return state
    }
}

export default toastReducer
